import React from 'react';

export const letsGetInTouch = {
    title: (
        <>
            Let's Get<br />
            In Touch
        </>
    ),
    subTitle: 'Contact us today to learn more about how our mathematically-inspired AI & quantum technologies can help you achieve your goals',
    contacts: [
        {
            icon: 'icon-phone-filled',
            url: 'tel: +97430736375',
            children: '+974 3073 6375',
        },
        {
            icon: 'icon-phone-filled',
            url: 'tel: +16512000711',
            children: '+1 651 200 0711 (US)',
        },
        {
            icon: 'icon-email-filled',
            url: 'mailto:info@qamia.co',
            children: 'info@qamia.co',
        },
        {
            icon: 'icon-linkedin-filled',
            url: 'https://www.linkedin.com/company/qamia-ai',
            children: '@qamia-ai',
        },
        {
            icon: 'icon-planet',
            url: 'https://www.google.com/maps/d/u/0/edit?mid=1d65fu5rfSYh7cJybK9MFirfbPjsty4o&usp=sharing',
            children: 'Doha | Abu Dhabi | USA',
        },
    ],
};

export const notFoundIntro = {
    cta: {
        url: '/',
        children: 'Go Home',
    },
    title: 'Page Not Found',
    subTitle: "We are sorry, we couldn't find what you were looking for.",
};
